import useFieldState from "@/common/hooks/hook-wrappers/useInformedFieldStateWrapper"
import {
  getSearchParam 
} from "@/common/hooks/useSearchParam"
import {
  useFormApi 
} from "informed"
import {
  useSearchParams 
} from "next/navigation"
import {
  useCallback, useEffect, useRef 
} from "react"

/**
 * Returns props necessary to render a SearchField component.
 */
export const useSearchField = (props) => {
  const {
    isSearchOpen, setIsAutoCompleteOpen 
  } = props

  const inputRef = useRef()
  const {
    value 
  } = useFieldState("search_query")
  const formApi = useFormApi()

  const search = useSearchParams()

  const resetForm = useCallback(() => {
    formApi.reset()
  }, [formApi])

  // When the search field is opened focus on the input.
  useEffect(() => {
    if (isSearchOpen && inputRef.current) {
      inputRef.current.fieldApi.setFocused(true)
      setIsAutoCompleteOpen(true)
    }
  }, [isSearchOpen, setIsAutoCompleteOpen])

  // Pre-populate the search field with the search term from the URL.
  // We purposefully only ever run this effect on initial mount.
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const urlTerm = getSearchParam("query", search)

    if (!formApi || !urlTerm) {
      return
    }

    formApi.setValue("search_query", urlTerm)
  }, [])
  /* eslint-enable react-hooks/exhaustive-deps */

  return {
    inputRef,
    resetForm,
    value,
  }
}
